import { Injectable } from '@angular/core'
import { Form, FormGroup } from '@angular/forms'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'
import { RequestsService } from 'src/app/_shared/services/requests.service'
import { INotificationResponse, INotification } from '../push-notifications.interfaces'

@Injectable({
  providedIn: 'root',
})
export class NotificationsService {
  constructor(private requestService: RequestsService) {}
  get(
    params: { [key: string]: any } = {}
  ): Observable<INotificationResponse> {
    const queryParams = new URLSearchParams(params).toString()
    return this.requestService.dash_get(`suppliers?${queryParams}`, null).pipe(
      map((val) => {
        return { data: val.data, total: val.total }
      })
    )
  }


  createNotifications(data: FormData) {
    return this.requestService.notifyPost('/', data)
  }

  notificationRecipients(data: FormGroup){
    return this.requestService.notifyPost('/users', data)
  }

  getNotifications(data: any): Observable<INotification[]> {
    const queryParams = new URLSearchParams(data).toString()
    return this.requestService.notifyGet(`/?${queryParams}`,)
  }
}
